'use strict';
(function () {

	if (!customElements.get('sticky-atc-bar')) {

    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
				this.setStickyBarHeight.bind(this)			
				this.parent = this.closest('.sticky-atc-bar');
				this.formBtn = this.querySelector('.button-add-card');
      }

      connectedCallback() {
				this.attachResizeHandler(); 
				this.setStickyBarHeight(); // Need for correctly positioning scroll to top btn
				this.markEmptyStrike();
				this.attachShareHandler();
				this.updateResponsiveButtonTitle();
      }

      disconnectedCallback() {
        this.cleanup(); // Clean up listeners and observers
      }

			toggleAddButton(disable = true, text, modifyClass = true) {
				const addButton = this.formBtn;
				if (!addButton) return;

				const addButtonText = addButton.querySelector('span');

				if (disable) {
					addButton.setAttribute('disabled', 'disabled');
					if (text) {
						if (addButtonText) addButtonText.textContent = text;
					}
				} else {
					addButton.removeAttribute('disabled');
					if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
				}

				if (!modifyClass) return;
			}
			
			markEmptyStrike() {
				const wrapper = this.querySelector('.price');
				if (!wrapper) return;
				const strike = wrapper.querySelector('.price__sale .price-item--regular');
				if (!strike) return;
				const txt = (strike.textContent || '').trim();
				const isEmpty = txt.length === 0;
				strike.classList.toggle('is-empty', isEmpty);
				const spanWrap = strike.closest('span');
				if (spanWrap) {
					spanWrap.classList.toggle('is-empty', isEmpty);
					spanWrap.style.display = isEmpty ? 'none' : '';
				}
				wrapper.classList.toggle('has-strike', !isEmpty);
			}

			getCurrentPriceText() {
				const salePrice = this.querySelector('.price__sale .price-item--sale');
				const regularPrice = this.querySelector('.price__regular .price-item--regular');
				const fallbackPrice = this.querySelector('.price .price-item');
				const candidate = salePrice || regularPrice || fallbackPrice;
				return candidate ? (candidate.textContent || '').trim() : '';
			}

			updateResponsiveButtonTitle() {
				const addButton = this.formBtn;
				if (!addButton || addButton.hasAttribute('disabled')) return;
				if (this.parent && this.parent.classList.contains('sticky-atc-bar--daily-ritual')) return;
				const addButtonText = addButton.querySelector('span');
				if (!addButtonText) return;

				if (window.innerWidth < 750) {
					const priceText = this.getCurrentPriceText();
					if (priceText) {
						addButtonText.textContent = window.themeStrings.addOneToCartFor.replace('[price]', priceText);
						return;
					}
				}

				addButtonText.textContent = window.variantStrings.addToCart;
			}

			setStickyBarHeight() {
				let height = 0;
				if (this.parent) {
					height = this.parent.offsetHeight;
				}

        document.documentElement.style.setProperty('--atc-bar-height', `${height}px`);
      }

			attachShareHandler() {
				const shareButton = this.querySelector('.sticky-atc-share');
				if (!shareButton) return;

				const hasWebShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';
				if (!hasWebShare && !navigator.clipboard) {
					shareButton.classList.add('hidden');
					return;
				}

				if (shareButton.dataset.shareBound === 'true') return;
				shareButton.dataset.shareBound = 'true';

				shareButton.addEventListener('click', async () => {
					const shareTitle = shareButton.getAttribute('data-share-title') || document.title;
					const shareUrl = window.location.href || shareButton.getAttribute('data-share-url');

					if (typeof navigator.share === 'function') {
						try {
							await navigator.share({
								text: `${shareTitle}\n${shareUrl}`,
							});
							return;
						} catch (error) {
							if (error.name === 'AbortError') return;
						}
					}

					if (navigator.clipboard && navigator.clipboard.writeText) {
						try {
							await navigator.clipboard.writeText(shareUrl);
						} catch (error) {
						}
					}
				});
			}

      attachResizeHandler() {
        this.resizeObserver = new ResizeObserver(() => this.setStickyBarHeight());
        this.resizeObserver.observe(this);
        window.addEventListener('resize', () => {
					this.setStickyBarHeight.call(this)
					this.updateResponsiveButtonTitle();
				});
      }

			cleanup() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect(); // Stop observing size changes
        }
      }	
    }

    customElements.define('sticky-atc-bar', StickyAtcBar);

		function checkBarVisibility() {
			const stickyAtcBar = document.querySelector(".sticky-atc-bar");
			const productVisible = document.querySelector(".product .product__info-wrapper");
			document.addEventListener("scroll", (e) => {
				let productVisibleHeight = productVisible.offsetHeight / 2;
				let scrolled = document.scrollingElement.scrollTop;
		
				if (scrolled > productVisibleHeight && !stickyAtcBar.classList.contains("js-hidden")) {
					stickyAtcBar.classList.add('atc-visible');
				} else {
					stickyAtcBar.classList.remove('atc-visible');
				}
			});
		}

		document.addEventListener('DOMContentLoaded', checkBarVisibility);
		document.addEventListener('shopify:section:load', checkBarVisibility);

		function addStickySpace() {
			const checkMobileStickyBar = document.querySelector('.mobile-sticky-bar ');
			const stickyAtcBar = document.querySelector(".sticky-atc-bar");
			const style = stickyAtcBar.dataset.style;
			const bottom = style == 'default' || style == 'default-swatches' | window.innerWidth < 750 ? 0 : 15;

			if ( window.innerWidth < 750 && checkMobileStickyBar && checkMobileStickyBar.classList.contains('active') ) {
				const mobileStickyBarHeight = checkMobileStickyBar.offsetHeight;
				stickyAtcBar.style.bottom = `${mobileStickyBarHeight + bottom}px`;
			} else {
				stickyAtcBar.style.bottom = `${bottom}px`;
			}
		}

		// document.addEventListener('DOMContentLoaded', addStickySpace);
		// document.addEventListener('shopify:section:load', addStickySpace);
		// window.addEventListener('resize', addStickySpace);
		// window.addEventListener('scroll', addStickySpace);

	}

	const stickyAtcBtn = document.querySelector('.sticky-atc-bar__close');

	if (stickyAtcBtn) {
		const addOnClickHandler = () => {
			const stickyAtcBar = document.querySelector(".sticky-atc-bar");
			if (!stickyAtcBar) return;

			stickyAtcBtn.addEventListener('click', () => {
				stickyAtcBar.classList.add('js-hidden');
				stickyAtcBar.classList.remove('atc-visible');
			})
		}

		addOnClickHandler();
	}
})();
